import EditDirectDebitCardForm from './EditDirectDebitCardForm';

export default EditDirectDebitCardForm;
